<template>
    <a
        v-push="routerPage"
        class="btn btn-s btn-transparent btn-fluid display-flex justify-content-space-between segment-link"
        :class="{active: isActive}">
        <span :title="segment.data.name" class="text-left segment-link-name">{{segment.data.name}}</span>
        <span class="text-muted segment-link-count">{{segment.$recordCount | approximateNumber({round: true})}}</span>
    </a>
</template>

<script>
    import SegmentDataModel from '@/common/models/segment-data-model';
    import SegmentModel from '@/common/models/segment-model';
    import {mapGetters} from 'vuex';

    export default {
        name: 'segment-link',
        props: {
            segment: {
                type: SegmentModel,
            },
        },
        computed: {
            ...mapGetters({
                activeSegment: 'segments/activeSegment',
            }),
            routerPage() {
                return {
                    name: this.segment.data.page === SegmentDataModel.Pages.lists
                        ? 'lists'
                        : 'customer-details',
                    params: {
                        segmentId: this.segment.id,
                    },
                };
            },
            isActive() {
                return this.activeSegment && this.segment.id === this.activeSegment.id;
            },
        },
    };
</script>
